import {HttpClientService} from './httpClient/httpclient.service';
import {Observable} from 'rxjs';
import {ListMetadata} from '../models/list-metadata.model';
import {map} from 'rxjs/operators';

///Classe astratta per modellare il comportamento standard dei service di FE per le operazoini CRUD
///Utilizza già il metodo list paginato della KoncentroPagedDao
export class IService<Model extends { id?: any }> {
  public baseUrl = null
  public entityUrl = null

  constructor(
    private http: HttpClientService,
    baseUrl: string,
    entityUrl: string
  ) {
    this.baseUrl = baseUrl
    this.entityUrl = entityUrl
  }

  get _http() { return this.http; }

  get(id): Observable<Model> {
    return this.http.get(`/${this.baseUrl}/${this.entityUrl}/${id}`);
  }

  list (
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable <{data: Array<Model>, metadata: ListMetadata}> {
    let params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);

    //FIXME: il replace è stato necessario perché un bug di angular non fa l'escape del +
    //FIXME: valutare se gestire la cosa con un interceptor custom come indicato qui https://stackoverflow.com/questions/45428842/angular-url-plus-sign-converting-to-space
    return this.http.getPaged(`/${this.baseUrl}/${this.entityUrl}${(params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B') : '' )}`)

  }

  update(model: Model): Observable<Model> {
    return this.http.put(`/${this.baseUrl}/${this.entityUrl}/${model.id}`, model);
  }

  create(model: Model): Observable<Model> {
    return this.http.post(`/${this.baseUrl}/${this.entityUrl}`, model)
  }

  delete(id): Observable<Model> {
    return this.http.delete(`/${this.baseUrl}/${this.entityUrl}/${id}`)
  }

}



// WEBPACK FOOTER //
// ./src/app/services/IService.ts